import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const STATUS_STYLES = {
  new: "bg-[#e6f4ea] text-[#1e7e34]",
  read: "bg-[#f4f4f4] text-[#555555]",
  archived: "bg-[#f4f4f4] text-[#6b6b6b]",
};

const AdminInquiriesPage = () => {
  const [inquiries, setInquiries] = useState(null);

  const load = () =>
    axios.get(`${API}/admin/inquiries`, { withCredentials: true }).then((res) => setInquiries(res.data));

  useEffect(() => {
    load();
  }, []);

  async function setStatus(inquiry, status) {
    await axios.patch(
      `${API}/admin/inquiries/${inquiry.id}`,
      { status },
      { withCredentials: true }
    );
    load();
  }

  return (
    <div data-testid="admin-inquiries">
      <h1 className="font-disp text-3xl text-[#121212] mb-2">Inquiries</h1>
      <p className="text-sm text-[#555555] mb-8">
        Contact form submissions, newest first.
      </p>

      {inquiries === null ? (
        <p className="text-xs font-mono uppercase tracking-[.14em] text-[#555555]">Loading…</p>
      ) : inquiries.length === 0 ? (
        <div className="bg-white border border-[#e5e5e5] p-10 text-center">
          <p className="text-sm text-[#555555]">No inquiries yet.</p>
        </div>
      ) : (
        <div className="bg-white border border-[#e5e5e5] divide-y divide-[#e5e5e5]">
          {inquiries.map((inq) => (
            <div key={inq.id} data-testid={`inquiry-row-${inq.id}`} className="p-5">
              <div className="flex flex-col md:flex-row md:items-start justify-between gap-4">
                <div className="min-w-0">
                  <p className="font-disp text-lg text-[#121212]">{inq.name}</p>
                  <p className="text-xs font-mono text-[#6b6b6b] mb-2">
                    {inq.email} · {inq.focus}
                    {inq.talent ? ` · Collaborator: ${inq.talent}` : ""} ·{" "}
                    {new Date(inq.created_at).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" })}
                  </p>
                  {inq.message && (
                    <p className="text-sm text-[#555555] leading-relaxed">{inq.message}</p>
                  )}
                </div>
                <div className="flex items-center gap-4 shrink-0">
                  <span className={`text-xs font-mono uppercase tracking-[.14em] px-2 py-1 ${STATUS_STYLES[inq.status] || STATUS_STYLES.new}`}>
                    {inq.status}
                  </span>
                  {inq.status === "new" && (
                    <button
                      type="button"
                      onClick={() => setStatus(inq, "read")}
                      data-testid={`inquiry-read-${inq.id}`}
                      className="text-xs font-mono uppercase tracking-[.14em] text-[#121212] underline underline-offset-4 hover:text-[#e02020]"
                    >
                      Mark Read
                    </button>
                  )}
                  {inq.status !== "archived" && (
                    <button
                      type="button"
                      onClick={() => setStatus(inq, "archived")}
                      data-testid={`inquiry-archive-${inq.id}`}
                      className="text-xs font-mono uppercase tracking-[.14em] text-[#6b6b6b] hover:text-[#e02020]"
                    >
                      Archive
                    </button>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default AdminInquiriesPage;
